import { useif } from "../state/types";
var bind = function (entitylink) {
    var _a;
    var name = entitylink.name, getter = entitylink.getter, setter = entitylink.setter, validator = entitylink.validator;
    var value = null;
    if (getter != null) {
        value = getter(name);
    }
    else if (entitylink.value == null) {
        value = "";
    }
    else {
        value = entitylink.value;
    }
    var onChange = (_a = entitylink.onChange) !== null && _a !== void 0 ? _a : useif(setter, function (value) { return setter(name, value, validator, true); });
    return {
        value: value,
        onChange: onChange
    };
};
export { bind };
